/* theme.liquid inline script (was L1152) */
(function () {
        function init() {
          var section = document.querySelector('[id$="__content_tabs_subavatar"]');
          if (!section) return;
          if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  entry.target.classList.add('opt-stagger-visible');
                  io.unobserve(entry.target);
                }
              });
            }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
            io.observe(section);
          } else {
            section.classList.add('opt-stagger-visible');
          }
          setTimeout(function () {
            if (!section.classList.contains('opt-stagger-visible')) {
              section.classList.add('opt-stagger-visible');
            }
          }, 1500);
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init);
        } else {
          init();
        }
      })();
/* theme.liquid inline script (was L1187) */
(function () {
        function init() {
          var section = document.querySelector('[id$="__content_tabs_MAYF9d"]');
          if (!section) return;
          if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  entry.target.classList.add('opt-flow-visible');
                  io.unobserve(entry.target);
                }
              });
            }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
            io.observe(section);
          } else {
            section.classList.add('opt-flow-visible');
          }
          setTimeout(function () {
            if (!section.classList.contains('opt-flow-visible')) {
              section.classList.add('opt-flow-visible');
            }
          }, 1500);
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init);
        } else {
          init();
        }
      })();
/* theme.liquid inline script (was L1231) */
(function () {
        function init() {
          // Inject scroll progress bar
          var progress = document.createElement('div');
          progress.className = 'opt-scroll-progress';
          document.body.appendChild(progress);

          // Inject back-to-top button
          var backToTop = document.createElement('button');
          backToTop.className = 'opt-back-to-top';
          backToTop.setAttribute('aria-label', 'Back to top');
          backToTop.innerHTML =
            '<svg viewBox="0 0 24 24"><polyline points="18 15 12 9 6 15"></polyline></svg>';
          backToTop.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          });
          document.body.appendChild(backToTop);

          // Throttled scroll handler — RAF coalesces fast scroll events
          var ticking = false;
          function updateScroll() {
            var docH = document.documentElement.scrollHeight - window.innerHeight;
            var scrolled = window.scrollY || window.pageYOffset;
            var pct = docH > 0 ? (scrolled / docH) * 100 : 0;
            progress.style.width = pct + '%';
            if (scrolled > window.innerHeight * 0.6) {
              backToTop.classList.add('opt-visible');
            } else {
              backToTop.classList.remove('opt-visible');
            }
            ticking = false;
          }
          window.addEventListener(
            'scroll',
            function () {
              if (!ticking) {
                window.requestAnimationFrame(updateScroll);
                ticking = true;
              }
            },
            { passive: true }
          );
          updateScroll();
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init);
        } else {
          init();
        }
      })();
/* theme.liquid inline script (was L1295) */
(function () {
        // Sections that own their own animation OR are above-the-fold — never fade these.
        var EXCLUDE_SUFFIXES = [
          '__optistasis_schema_SEO',
          '__shop_product_details_JbqzwH',
          '__scrolling_features_bar_QmiYpj',
          '__content_tabs_subavatar',
          '__content_tabs_MAYF9d'
        ];
        function shouldExclude(id) {
          for (var i = 0; i < EXCLUDE_SUFFIXES.length; i++) {
            if (id.indexOf(EXCLUDE_SUFFIXES[i]) !== -1) return true;
          }
          return false;
        }
        function init() {
          var sections = document.querySelectorAll('section[id^="shopify-section-"]');
          var animated = [];
          sections.forEach(function (s) {
            if (shouldExclude(s.id)) return;
            s.setAttribute('data-opt-fade', '');
            animated.push(s);
          });
          if (!animated.length) return;
          if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  entry.target.classList.add('opt-section-in');
                  io.unobserve(entry.target);
                }
              });
            }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
            animated.forEach(function (s) { io.observe(s); });
          } else {
            animated.forEach(function (s) { s.classList.add('opt-section-in'); });
          }
          // Safety net — force-reveal anything still hidden after 4s
          setTimeout(function () {
            animated.forEach(function (s) {
              if (!s.classList.contains('opt-section-in')) {
                s.classList.add('opt-section-in');
              }
            });
          }, 4000);
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init);
        } else {
          init();
        }
      })();
/* theme.liquid inline script (was L1353) */
(function () {
        /* optistasis-pdp-bundle-price-sync v2 */
        function syncTopPrice() {
          var active = document.querySelector('.obs-card.obs-active');
          if (!active) return;
          var price = (active.querySelector('.obs-price') || {}).textContent;
          var compare = (active.querySelector('.obs-compare') || {}).textContent;
          if (price) price = price.trim();
          if (compare) compare = compare.trim();
          if (!price) return;
          var priceBlock = document.querySelector('[id^="block-price_"] .shop-product-price-block');
          if (priceBlock) priceBlock.textContent = price;
          var compareBlock = document.querySelector('[id^="block-price_"] .shop-compare-price');
          if (compareBlock) {
            if (compare) { compareBlock.textContent = compare; compareBlock.style.display = ''; }
            else { compareBlock.style.display = 'none'; }
          }
          var saveEl = document.querySelector('[id^="block-price_"] .shop-save-price');
          if (saveEl) {
            var pNum = parseFloat((price || '').replace(/[^0-9.]/g, ''));
            var cNum = parseFloat((compare || '').replace(/[^0-9.]/g, ''));
            if (pNum > 0 && cNum > 0 && cNum > pNum) {
              var pct = Math.round((1 - pNum / cNum) * 100);
              var svg = saveEl.querySelector('svg');
              var styleEl = saveEl.querySelector('style');
              saveEl.innerHTML = (styleEl ? styleEl.outerHTML : '') + (svg ? svg.outerHTML : '') + ' SAVE ' + pct + '%';
              saveEl.style.display = '';
            } else {
              saveEl.style.display = 'none';
            }
          }
        }
        function init() {
          syncTopPrice();
          document.addEventListener('click', function (e) {
            var card = e.target && e.target.closest ? e.target.closest('.obs-card') : null;
            if (!card) return;
            setTimeout(syncTopPrice, 0);
          });
          var cards = document.querySelectorAll('.obs-card');
          if (cards.length && window.MutationObserver) {
            var mo = new MutationObserver(function (mutations) {
              for (var i = 0; i < mutations.length; i++) {
                if (mutations[i].attributeName === 'class') { syncTopPrice(); return; }
              }
            });
            cards.forEach(function (c) { mo.observe(c, { attributes: true, attributeFilter: ['class'] }); });
          }
        }
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init);
        } else {
          init();
        }
      })();
